import { z } from 'zod';

/**
 * Permission Create — POST /api/eraf/permissions
 * code: create-only, pattern ^[A-Z][A-Z0-9]*_[A-Z][A-Z0-9]*$
 */
export const permissionCreateSchema = z.object({
  code: z
    .string()
    .min(1, '권한 코드를 입력해주세요')
    .max(128, '권한 코드는 128자 이하여야 합니다')
    .regex(
      /^[A-Z][A-Z0-9]*_[A-Z][A-Z0-9]*$/,
      '대문자·숫자·밑줄만 사용하고 구분자(_)를 포함해야 합니다 (예: USER_READ)',
    ),
  resource: z
    .string()
    .min(1, '리소스를 입력해주세요')
    .max(64, '리소스는 64자 이하여야 합니다'),
  action: z
    .string()
    .min(1, '액션을 입력해주세요')
    .max(64, '액션은 64자 이하여야 합니다'),
  nameKo: z
    .string()
    .min(1, '한글 이름을 입력해주세요')
    .max(128, '한글 이름은 128자 이하여야 합니다'),
  description: z
    .string()
    .max(512, '설명은 512자 이하여야 합니다')
    .optional(),
});

export type PermissionCreateFormValues = z.infer<typeof permissionCreateSchema>;

/**
 * Permission Update — PATCH /api/eraf/permissions/{id}
 * code 는 수정 불가 → 스키마에서 제외
 */
export const permissionUpdateSchema = z.object({
  nameKo: z
    .string()
    .min(1, '한글 이름을 입력해주세요')
    .max(128, '한글 이름은 128자 이하여야 합니다')
    .optional(),
  resource: z
    .string()
    .min(1, '리소스를 입력해주세요')
    .max(64, '리소스는 64자 이하여야 합니다')
    .optional(),
  action: z
    .string()
    .min(1, '액션을 입력해주세요')
    .max(64, '액션은 64자 이하여야 합니다')
    .optional(),
  description: z
    .string()
    .max(512, '설명은 512자 이하여야 합니다')
    .optional(),
});

export type PermissionUpdateFormValues = z.infer<typeof permissionUpdateSchema>;
